import { render, staticRenderFns } from "./LedgerEntriesTable.vue?vue&type=template&id=46503842&"
import script from "./LedgerEntriesTable.vue?vue&type=script&lang=js&"
export * from "./LedgerEntriesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports